import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import IUIActions from "../IUIActions";
import IGame from "../../game/IGame";
import DesktopUIStates from "../desktop/DesktopUIStates";
import DesktopUI from "../desktop/DesktopUI";
import Wallet from "../../wallet/Wallet";
import DesktopUIController from "../desktop/DesktopUIController";
import {BASE_ELEMENT_IDS} from "../BaseDOM";

class VLT2UIStates extends DesktopUIStates {

    constructor(
        @inject(SERVICE_IDENTIFIER.UIController) uiController: DesktopUIController,
        @inject(SERVICE_IDENTIFIER.UI) ui: DesktopUI,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame,
        @inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig
    ) {
        super(uiController, ui, game, uiActions, wallet, config);
    }

    stateInit(data) {
        super.stateInit(data)

        // if (this.config.get(CONFIG_PARAMS.DISPLAYS) === 2 && this.config.get(CONFIG_PARAMS.EXHIBITION) === "2") {
        //     let wintableControlsWrapper = document.getElementById(BASE_ELEMENT_IDS.WINTABLE_CONTROLS_WRAPPER);
        //     $(wintableControlsWrapper).show();
        // }
    }
}

export default VLT2UIStates;